(() => {
      if (window.ctKzBuilderV624) return;
      window.ctKzBuilderV624 = true;
      const controllers = new WeakMap();
      
      const verifiedProfiles = {
        '0000': { name: 'Configuración base', desc: 'Todos los switches en reposo. Guía visual de la selección; no es una medición.', eq: [42,42,42,42,42,42,42,42,42,42,42,42] },
        '1000': { name: 'S1 activo', desc: 'Combinación visual con S1 activo. Verificá la posición en la guía del producto; no es una medición.', eq: [82,82,82,42,42,42,42,42,42,42,42,42] },
        '0100': { name: 'S2 activo', desc: 'Combinación visual con S2 activo. Verificá la posición en la guía del producto; no es una medición.', eq: [42,42,42,82,82,82,42,42,42,42,42,42] },
        '0010': { name: 'S3 activo', desc: 'Combinación visual con S3 activo. Verificá la posición en la guía del producto; no es una medición.', eq: [42,42,42,42,42,42,82,82,82,42,42,42] },
        '0001': { name: 'S4 activo', desc: 'Combinación visual con S4 activo. Verificá la posición en la guía del producto; no es una medición.', eq: [42,42,42,42,42,42,42,42,42,82,82,82] },
        '1100': { name: 'S1 + S2 activos', desc: 'Combinación visual con S1 y S2 activos. No representa una medición de sonido.', eq: [82,82,82,82,82,82,42,42,42,42,42,42] },
        '1010': { name: 'S1 + S3 activos', desc: 'Combinación visual con S1 y S3 activos. No representa una medición de sonido.', eq: [82,82,82,42,42,42,82,82,82,42,42,42] },
        '1001': { name: 'S1 + S4 activos', desc: 'Combinación visual con S1 y S4 activos. No representa una medición de sonido.', eq: [82,82,82,42,42,42,42,42,42,82,82,82] },
        '0110': { name: 'S2 + S3 activos', desc: 'Combinación visual con S2 y S3 activos. No representa una medición de sonido.', eq: [42,42,42,82,82,82,82,82,82,42,42,42] },
        '0101': { name: 'S2 + S4 activos', desc: 'Combinación visual con S2 y S4 activos. No representa una medición de sonido.', eq: [42,42,42,82,82,82,42,42,42,82,82,82] },
        '0011': { name: 'S3 + S4 activos', desc: 'Combinación visual con S3 y S4 activos. No representa una medición de sonido.', eq: [42,42,42,42,42,42,82,82,82,82,82,82] },
        '1110': { name: 'S1 + S2 + S3 activos', desc: 'Combinación visual con S1, S2 y S3 activos. No representa una medición de sonido.', eq: [82,82,82,82,82,82,82,82,82,42,42,42] },
        '1101': { name: 'S1 + S2 + S4 activos', desc: 'Combinación visual con S1, S2 y S4 activos. No representa una medición de sonido.', eq: [82,82,82,82,82,82,42,42,42,82,82,82] },
        '1011': { name: 'S1 + S3 + S4 activos', desc: 'Combinación visual con S1, S3 y S4 activos. No representa una medición de sonido.', eq: [82,82,82,42,42,42,82,82,82,82,82,82] },
        '0111': { name: 'S2 + S3 + S4 activos', desc: 'Combinación visual con S2, S3 y S4 activos. No representa una medición de sonido.', eq: [42,42,42,82,82,82,82,82,82,82,82,82] },
        '1111': { name: 'S1 + S2 + S3 + S4 activos', desc: 'Combinación visual con los 4 switches activos. No representa una medición de sonido.', eq: [82,82,82,82,82,82,82,82,82,82,82,82] }
      };
      
      const legacyProfiles = {
        '1000': { name: 'Más graves', desc: 'Suma pegada y profundidad en bajos sin depender de apps.', eq: [90,95,90,75,55,40,35,30,30,35,30,25] },
        '0100': { name: 'Refuerzo medio-grave', desc: 'Más cuerpo en voces, guitarras e instrumentos.', eq: [60,75,90,85,75,60,45,35,30,30,35,40] },
        '1100': { name: 'Máximos graves', desc: 'La combinación más potente para electrónica, reggaeton y bajos pesados.', eq: [100,100,95,80,55,40,30,25,25,30,30,30] },
        '0010': { name: 'Medios y agudos', desc: 'Voces más claras e instrumentos más definidos.', eq: [40,45,50,60,75,85,90,85,75,70,65,60] },
        '0001': { name: 'Aire y brillo', desc: 'Más sensación de detalle en la parte alta.', eq: [35,40,45,50,60,70,75,85,95,90,85,80] },
        '0011': { name: 'Brillo y claridad', desc: 'Sonido abierto para voces, cine y detalles finos.', eq: [35,40,45,55,75,90,95,90,85,85,80,75] },
        '1010': { name: 'V-shape', desc: 'Grave y agudos potenciados para rock, gaming y música enérgica.', eq: [90,95,80,55,40,50,75,85,90,85,75,65] },
        '1001': { name: 'Graves + aire', desc: 'Punch abajo con brillo arriba. Muy usable para juegos y series.', eq: [88,92,82,60,45,40,55,70,85,90,80,70] },
        '0110': { name: 'Medios completos', desc: 'Voces e instrumentos balanceados con buen cuerpo.', eq: [50,60,75,85,90,90,80,70,55,50,50,45] },
        '0101': { name: 'Medios brillantes', desc: 'Voces claras con detalle alto sin empujar tanto el bajo.', eq: [50,55,70,80,85,80,75,75,80,80,75,70] },
        '1110': { name: 'Bajos y medios claros', desc: 'Pegada fuerte con presencia vocal definida.', eq: [92,95,90,85,80,80,75,70,65,60,55,50] },
        '1101': { name: 'Bajos con aire', desc: 'Pegada inferior y sensación más brillante arriba.', eq: [95,98,92,75,55,55,65,75,90,90,85,80] },
        '1011': { name: 'Bass + detail', desc: 'Graves potentes con más detalle percibido.', eq: [90,92,85,65,55,75,90,90,85,85,80,75] },
        '0111': { name: 'Medios + brillo', desc: 'Claridad por encima de pegada. Bueno para voces y podcasts.', eq: [40,50,65,80,90,90,85,85,80,80,75,70] },
        '1111': { name: 'Elevación total', desc: 'Perfil enérgico con todo arriba.', eq: [95,98,95,90,85,85,90,90,92,90,85,80] },
        '0000': { name: 'Plano', desc: 'Sin switches activos. Referencia base antes de ajustar.', eq: [50,55,55,55,55,55,55,55,55,55,55,55] }
      };
      

      const initRoot = (root) => {
        if (!root || root.dataset.ckzReady === '1') return;
        root.dataset.ckzReady = '1';
        const profiles = root.dataset.ckzMode === 'castor_pro_verified' ? verifiedProfiles : legacyProfiles;
        const abort = new AbortController();
        controllers.set(root, abort);
        const on = (target, event, listener) => target.addEventListener(event, listener, { signal: abort.signal });
        document.documentElement.classList.add('che-kz-pdp');

        const state = {
          variant: '',
          price: root.dataset.productPrice || '',
          pack: '',
          use: '',
          profile: '',
          combo: '',
          compatibility: ''
        };

        const updateProperties = () => {
          root.querySelectorAll('[data-switch-property]').forEach((input) => input.value = state.profile || '');
          root.querySelectorAll('[data-use-property]').forEach((input) => input.value = state.use || '');
          root.querySelectorAll('[data-pack-property]').forEach((input) => input.value = state.pack || '');
        };

        const currentContext = () => ({
          product: root.dataset.productTitle || '',
          variant: state.variant || '',
          price: state.price || '',
          pack: state.pack || '',
          use: state.use || '',
          profile: state.profile || '',
          combo: state.combo || '',
          compatibility: state.compatibility || '',
          url: window.location.href.split('#')[0]
        });

        const firstMatch = (selectorList, scope = document) => {
          if (!selectorList) return null;
          const selectors = selectorList.split(',').map((selector) => selector.trim()).filter(Boolean);
          for (const selector of selectors) {
            try {
              const match = scope.querySelector(selector);
              if (match && match.offsetParent !== null) return match;
            } catch (error) {
              continue;
            }
          }
          return null;
        };

        const syncShopifyContext = () => {
          const context = currentContext();
          updateProperties();

          try {
            window.localStorage.setItem('che_kz_shopify_context', JSON.stringify(context));
          } catch (error) {}

          root.dataset.shopifyContext = JSON.stringify(context);

          const eventDetail = { detail: context };
          document.dispatchEvent(new CustomEvent('che:kz:shopify:context', eventDetail));
          window.dispatchEvent(new CustomEvent('che:kz:shopify:context', eventDetail));
        };

        const updateWhatsapp = () => {
          syncShopifyContext();

          const number = root.dataset.whatsapp;
          if (!number) return;

          const params = new URLSearchParams(window.location.search);
          const attribution = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid', 'gclid']
            .map((key) => params.get(key) ? `${key}: ${params.get(key)}` : '')
            .filter(Boolean)
            .join(' | ');

          const lines = [
            root.dataset.baseMessage,
            state.variant ? `Variante: ${state.variant}` : '',
            state.price ? `Precio visto: ${state.price}` : '',
            state.pack ? `Pack seleccionado: ${state.pack}` : '',
            state.use ? `Uso principal: ${state.use}` : '',
            state.profile ? `Perfil de switches: ${state.profile}${state.combo ? ` (${state.combo})` : ''}` : '',
            state.compatibility ? `Compatibilidad: ${state.compatibility}` : '',
            attribution ? `Origen: ${attribution}` : '',
            `Link: ${window.location.href.split('#')[0]}`
          ].filter(Boolean);

          const href = `https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`;
          root.querySelectorAll('[data-che-whatsapp]').forEach((link) => link.setAttribute('href', href));
        };

        const submitShopifyCheckout = (sourceButton) => {
          syncShopifyContext();

          const detail = { detail: currentContext() };
          document.dispatchEvent(new CustomEvent('che:kz:shopify:checkout', detail));
          window.dispatchEvent(new CustomEvent('che:kz:shopify:checkout', detail));

          const form = sourceButton?.closest('form') || root.querySelector('.ckz-buy-form') || root.querySelector('.ckz-bundle-form') || root.querySelector('form[action*="/cart/add"]');
          if (form) {
            const nativeSubmitter = form.querySelector('button[type="submit"][name="add"], button[name="add"]');
            if (typeof form.requestSubmit === 'function') {
              nativeSubmitter ? form.requestSubmit(nativeSubmitter) : form.requestSubmit();
            } else if (nativeSubmitter) {
              nativeSubmitter.click();
            } else {
              form.submit();
            }
            return;
          }

          if (root.dataset.shopifyFallbackWhatsapp === 'true') {
            const fallback = root.querySelector('[data-che-whatsapp]');
            if (fallback) {
              fallback.click();
              return;
            }
          }

          window.location.href = '/cart';
        };

        const setVariant = (select) => {
          const option = select.options[select.selectedIndex];
          state.variant = option?.dataset.variantTitle || option?.textContent?.trim() || '';
          state.price = option?.dataset.price || state.price;
          root.querySelectorAll('[data-variant-id-hidden]').forEach((input) => input.value = select.value);
          root.querySelectorAll('[data-che-current-price]').forEach((node) => node.textContent = state.price);
          updateWhatsapp();
        };

        root.querySelectorAll('[data-variant-select]').forEach((select) => {
          setVariant(select);
          on(select, 'change', () => setVariant(select));
        });

        root.querySelectorAll('[data-shopify-checkout-trigger]').forEach((button) => {
          on(button, 'click', (event) => {
            event.preventDefault();
            submitShopifyCheckout(button);
          });
        });

        root.querySelectorAll('[data-pack-button]').forEach((button) => {
          on(button, 'click', () => {
            const group = button.closest('[data-bundles]') || root;
            group.querySelectorAll('[data-pack-button]').forEach((item) => item.classList.remove('is-selected'));
            button.classList.add('is-selected');
            state.pack = button.dataset.pack || '';
            root.querySelectorAll('[data-quantity-input]').forEach((input) => input.value = button.dataset.quantity || '1');
            updateWhatsapp();
          });
        });

        const firstPack = root.querySelector('[data-pack-button].is-selected');
        if (firstPack) {
          state.pack = firstPack.dataset.pack || '';
          root.querySelectorAll('[data-quantity-input]').forEach((input) => input.value = firstPack.dataset.quantity || '1');
        }

        root.querySelectorAll('[data-use-card]').forEach((button) => {
          on(button, 'click', () => {
            root.querySelectorAll('[data-use-card]').forEach((item) => item.classList.remove('is-active'));
            button.classList.add('is-active');
            state.use = button.dataset.use || '';
            const pattern = button.dataset.pattern;
            root.querySelectorAll('[data-switch-lab]').forEach((lab) => applyPattern(lab, pattern));
            updateWhatsapp();
          });
        });

        const firstUse = root.querySelector('[data-use-card].is-active');
        if (firstUse) state.use = firstUse.dataset.use || '';

        root.querySelectorAll('[data-compat-checker]').forEach((checker) => {
          const result = checker.querySelector('[data-compat-result]');
          const messages = {
            '3.5mm': 'Podés usarlo directo si tu equipo tiene entrada 3.5mm.',
            'usb-c': 'Probablemente necesitás adaptador USB-C a 3.5mm. Confirmamos el modelo antes de enviar.',
            'lightning': 'Probablemente necesitás adaptador Lightning a 3.5mm. Confirmamos compatibilidad antes de enviar.',
            'unknown': 'Mandanos foto del puerto por WhatsApp y te confirmamos.'
          };

          checker.querySelectorAll('[data-compat-option]').forEach((button) => {
            on(button, 'click', () => {
              checker.querySelectorAll('[data-compat-option]').forEach((item) => item.classList.remove('is-active'));
              button.classList.add('is-active');
              const option = button.dataset.compatOption || '';
              const label = button.dataset.compatLabel || option;
              state.compatibility = label;
              if (result) result.textContent = messages[option] || '';
              updateWhatsapp();
            });
          });
        });

        const applyPattern = (lab, pattern) => {
          if (!lab || !pattern || pattern.length !== 4) return;
          lab.querySelectorAll('[data-switch]').forEach((button, index) => {
            const isOn = pattern[index] === '1';
            button.classList.toggle('is-on', isOn);
            button.setAttribute('aria-pressed', isOn ? 'true' : 'false');
          });
          updateSwitchLab(lab);
        };

        const readPattern = (lab) => {
          return Array.from(lab.querySelectorAll('[data-switch]')).map((button) => button.classList.contains('is-on') ? '1' : '0').join('');
        };

        const updateSwitchLab = (lab) => {
          const pattern = readPattern(lab);
          const profile = profiles[pattern] || profiles['0000'];
          const combo = pattern.split('').map((bit, index) => bit === '1' ? `S${index + 1}` : '').filter(Boolean).join(' + ') || 'Sin switches';
          lab.querySelectorAll('[data-switch-eq] span').forEach((bar, index) => {
            bar.style.setProperty('--h', `${profile.eq[index] || 50}%`);
          });
          const title = lab.querySelector('[data-switch-title]');
          const copy = lab.querySelector('[data-switch-copy]');
          const comboNode = lab.querySelector('[data-switch-combo]');
          if (title) title.textContent = profile.name;
          if (copy) copy.textContent = profile.desc;
          if (comboNode) comboNode.textContent = combo;
          lab.querySelectorAll('[data-preset]').forEach((preset) => {
            const isActive = preset.dataset.preset === pattern;
            preset.classList.toggle('is-active', isActive);
            preset.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          state.profile = profile.name;
          state.combo = combo;
          updateWhatsapp();
        };

        root.querySelectorAll('[data-switch-lab]').forEach((lab) => {
          const initial = lab.dataset.defaultPattern || '1000';
          applyPattern(lab, initial);

          lab.querySelectorAll('[data-switch]').forEach((button) => {
            on(button, 'click', () => {
              const isOn = !button.classList.contains('is-on');
              button.classList.toggle('is-on', isOn);
              button.setAttribute('aria-pressed', isOn ? 'true' : 'false');
              updateSwitchLab(lab);
            });
          });

          lab.querySelectorAll('[data-preset]').forEach((preset) => {
            on(preset, 'click', () => {
              state.use = preset.dataset.useLabel || state.use;
              applyPattern(lab, preset.dataset.preset);
            });
          });
        });

        updateWhatsapp();
      };

      const selector = '.ct-kz-builder-v624[data-che-kz-builder]';
      const rootsIn = (scope) => [
        ...(scope.matches?.(selector) ? [scope] : []),
        ...scope.querySelectorAll(selector)
      ];
      const init = (scope) => rootsIn(scope).forEach(initRoot);
      document.addEventListener('shopify:section:load', (event) => init(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        rootsIn(event.target).forEach((root) => {
          controllers.get(root)?.abort();
          controllers.delete(root);
          delete root.dataset.ckzReady;
        });
        const remaining = Array.from(document.querySelectorAll(selector))
          .some((root) => !event.target.contains(root) && root.dataset.ckzReady === '1');
        if (!remaining) document.documentElement.classList.remove('che-kz-pdp');
      });
      init(document);
    })();

